import { IResortPageSnowInfo, IContactInformation } from 'api/resort/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import GoogleApiWrapper from '../ContactInformation/GoogleApiWrapper';
import { SectionHeader } from '../SectionHeader';
import styles from './styles.module.scss';

interface Props {
  description?: { dangerouslySetInnerHTML: { __html: string; }; };
  country: string;
  city: string;
  fullResort: IResortPageSnowInfo;
  contactInformation: IContactInformation;
}

export const HowToGetThereSection = ({
  description, country, city, fullResort, contactInformation,
}:Props) => {
  const { t } = useOTSTranslation('common');

  return (
    <section id={styles.howToGetThere}>
      <SectionHeader
        title={t('resort.overview.transportationTab')}
        description={description}
      />
      <div>
        <GoogleApiWrapper
          place={`${country} ${city} ${fullResort.title}`}
          lat={contactInformation.address.lat}
          lng={contactInformation.address.lng}
        />
      </div>
    </section>
  );
};
